var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userInfo)?_c('div',[(_vm._isPartner)?_c('div',[_c('partner-dashboard',{attrs:{"user-id":_vm.userInfo.id}})],1):_vm._e(),(_vm._isAdmin || _vm._isMarketing)?_c('admin-dashboard'):_vm._e()],1):_c('b-spinner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }